import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-success',
  templateUrl: './reset-success.component.html',
  styleUrls: ['../forgot-password/forgot-password.component.css','./reset-success.component.css']
})
export class ResetSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
